import { Routes } from '@angular/router';

import { AuthGuard } from '../auth.guard';
import { RootComponent } from '../root/root.component';
import { ReleaseSettingsListComponent } from './release-settings-list/release-settings-list.component';
import { ReleaseSettingsEditComponent } from './release-settings-edit/release-settings-edit.component';

export const routing: Routes = [
  {
    path: 'release',
    component: RootComponent, canActivate: [AuthGuard],

    children: [
      { path: '', component: ReleaseSettingsListComponent },
      { path: 'list', component: ReleaseSettingsListComponent },
      { path: 'add', component: ReleaseSettingsEditComponent },
      { path: 'edit/:releaseSettingId', component: ReleaseSettingsEditComponent },
    ]
  }
];
